import { Model } from './model';
import { FilterHandler } from '../shared/filter-handler';
import { StockMinimal } from './stock-minimal';

export class Zone extends Model {
  id: number;
  name: string;
  polygon: string;
  zones: StockMinimal[] = [];

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const zone = new Zone(values);

    if (values['stock']) {
      for (const stock of values['stock']) {
        zone.zones.push(new StockMinimal(stock));
      }
    }
    return new Zone(values);
  }
}

export class ZoneFilter extends FilterHandler {
  name: string;

  constructor(values: Object = {}) {
    super();

    this.name = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/zone.ts